export default __webpack_public_path__ + "static/media/template_pro__0002_25---DannyTang.7403c93b.png";